





















import { defineComponent, inject } from '@vue/composition-api'

// Store
import { StoreKey as InputStoreKey } from '@/store/Input'
import { StoreKey as FormStoreKey } from '@/store/Form'
import { StoreKey as ErrorStoreKey } from '@/store/Error'
import { StoreKey as ValidatedStoreKey } from '@/store/Validated'

// Component
import QuestionRow from '@/component/form/Field/QuestionRow.vue'

export default defineComponent({
    components: {
        QuestionRow,
    },
    setup() {
        const formStore = inject(FormStoreKey)
        if (!formStore) {
            throw new Error(`${FormStoreKey} is not provided`)
        }
        const inputStore = inject(InputStoreKey)
        if (!inputStore) {
            throw new Error(`${InputStoreKey} is not provided`)
        }
        const errorStore = inject(ErrorStoreKey)
        if (!errorStore) {
            throw new Error(`${ErrorStoreKey} is not provided`)
        }
        const validatedStore = inject(ValidatedStoreKey)
        if (!validatedStore) {
            throw new Error(`${ValidatedStoreKey} is not provided`)
        }

        // Prepare empty values
        formStore.questions.map((question) => {
            if (inputStore.question[question.ordered] === undefined) {
                if (question.is_checkbox) {
                    inputStore.question[question.ordered] = []
                } else {
                    inputStore.question[question.ordered] = null
                }
            }
            if (validatedStore.question[question.ordered] === undefined) {
                validatedStore.question[question.ordered] = 0
            }

            if (inputStore.question_other[question.ordered] === undefined) {
                inputStore.question_other[question.ordered] = {}
            }
            if (question.answer) {
                question.answer.map((answer) => {
                    if (
                        inputStore.question_other[question.ordered][
                            answer.ordered
                        ] === undefined
                    ) {
                        inputStore.question_other[question.ordered][
                            answer.ordered
                        ] = null
                    }
                })
            }
        })

        return {
            formStore,
            inputStore,
            errorStore,
        }
    },
})
